<template>

    <div class="version-dialog-container"  v-if="showDialog">
        <div class="version-dialog-box">
            <div class="close pointer" @click="handleCancel">
                <img src="../../assets/closethree.png" alt="" class="icon-close">
            </div>
            <div class="version-time"><text style="color: #707CAC;">系统维护时间：</text>{{ formatCreateTime(versionData.createTime) }}</div>
            <div class="version-dialog-content">
                <div class="version-icon-box">
                    <img src="https://new-bullet-static.oss-cn-shanghai.aliyuncs.com/miniprogram/pay/ysQqqlXiYc16fA0g97p1lFopOqNoMJXl.png" alt="" class="version-icon default-icon">
                </div>
                <div class="description text-center fc-lightgray">
                    <div class="update-content">
                        <div class="update-title fs-16 mg-b-8">亲爱的客户：</div>
                        <div v-if="versionData && versionData.versionDesc" >
                            <div class="fs-16 update-title" v-html="getUpdateContent()"></div>
                        </div>
                    </div>
                    <div class="button-box flex flex-jc-c mg-t-20 gap-12">
                        <div class="btn-confirm pointer" :style="confirmButtonStyle" @click="handleConfirm">
                            知道了
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VersionUpdate',
    data() {
        return {
            showDialog: false,
            versionData: {},
            options: {},
            onRefresh: null,
            onCancel: null
        }
    },
    computed: {
        confirmButtonStyle() {
            const style = {}
            if (this.options.primaryColor) {
                style.backgroundColor = this.options.primaryColor
                style.borderColor = this.options.primaryColor
            }
            if (this.options.buttonStyle) {
                Object.assign(style, this.options.buttonStyle)
            }
            return style
        },
        hasUpdateContent() {
            return this.getUpdateContent() && this.getUpdateContent().length > 0
        }
    },
    mounted() {
        // 监听版本更新事件
        window.addEventListener('showVersionDialog', this.handleShowDialog)
        window.addEventListener('closeVersionDialog', this.handleCloseDialog)
    },
    beforeUnmount() {
        window.removeEventListener('showVersionDialog', this.handleShowDialog)
        window.removeEventListener('closeVersionDialog', this.handleCloseDialog)
    },
    methods: {
        formatCreateTime(time) {
        if (!time) return '';
        const date = new Date(time);
        const endTime = new Date(date.getTime() + 3 * 60 * 60 * 1000);

        const formatDate = (d) => {
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            return `${month}月${day}日`;
        };

        const formatTime = (d) => {
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        };

        return `${formatDate(date)} ${formatTime(date)} - ${formatTime(endTime)}`;
    },
        handleShowDialog(event) {
            const { data = {}, options = {}, onRefresh, onCancel } = event.detail
            console.log('Received version data:', data)
            console.log('Version dialog event detail:', event.detail)
            this.versionData = data
            this.options = options
            this.onRefresh = onRefresh
            this.onCancel = onCancel
            this.showDialog = true
        },
        handleCloseDialog() {
            this.showDialog = false
        },
        getUpdateContent() {
            console.log(this.versionData,'版本描述啦啦啦啦啦');

            if (this.versionData.versionDesc) {

                return this.versionData.versionDesc
            }
            return null
        },
        handleConfirm() {
            // 确认时更新状态为"已确认"
            const confirmKey = `${this.versionData.versionCode}_confirmed`;
            localStorage.setItem('versionPrompt', confirmKey);

            console.log('点击知道了，设置localStorage标记:', {
                versionCode: this.versionData.versionCode,
                confirmKey: confirmKey,
                实际存储的值: localStorage.getItem('versionPrompt'),
                设置成功: localStorage.getItem('versionPrompt') === confirmKey
            });

            // 关闭弹窗
            this.showDialog = false

            // 调用刷新回调（如果存在）
            if (this.onRefresh) {
                console.log(' 调用onRefresh回调')
                this.onRefresh(this.versionData)
            } else {
                console.log('默认刷新页面')
                // 延迟刷新，确保localStorage写入完成
                setTimeout(() => {
                    window.location.reload()
                }, 100)
            }
        },
        handleCancel() {
            if (this.onCancel) {
                this.onCancel(this.versionData)
            }
            // 根据取消模式设置不再提示
            const cancelMode = this.options.cancelMode || 'ignore-current-version'
            if (cancelMode === 'ignore-current-version') {
                localStorage.setItem('ignored-version', this.versionData.versionCode)
            }
            this.showDialog = false
        }
    }
}
</script>

<style lang="stylus" scoped>
.version-dialog-container
    position fixed
    left 0
    top 0
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.7)
    z-index 1000
    display flex
    align-items center
    justify-content center

.version-dialog-box
    width 720px
    border-radius 12px
    position relative

.version-time
    position absolute
    top 136px
    left 30px
    font-size: 18px
    color: #47494C
    font-weight: bold

.icon-close
    position absolute
    right 0px
    top 0px
    width 36px
    height 36px
    cursor pointer
    opacity 0.6
    &:hover
        opacity 1

.version-dialog-content
    text-align center

.version-icon-box
    display flex
    justify-content center
    align-items center

.version-icon
    width 100%

.title
    color #333
    font-weight bold

.description
    color #666
    line-height 1.5
    background: linear-gradient(180deg, #E8F5FF 0%, #F7F9FD 97%, #F9FEFF 100%);
    border-radius 0 0 24px 24px
    padding-bottom 20px

.update-content
    text-align left
    border-radius 14px
    padding 16px
    margin 0 10px 24px
    background: linear-gradient(180deg, #F7FEFF 0%, rgba(255, 255, 255, 0) 100%);

.update-title
    color: #3F4352

.button-box
    margin-top 24px

.btn-cancel
    width 120px
    height 40px
    line-height 40px
    text-align center
    border-radius 20px
    background #fff
    border 1px solid #ddd
    color #666
    transition all 0.3s ease
    &:hover
        background #f5f5f5

.btn-confirm
    width 120px
    height 40px
    line-height 40px
    text-align center
    border-radius 10px
    background: #3360FE;
    border 1px solid #409eff
    color #fff
    transition all 0.3s ease
    &:hover
        background #66b3ff
        border-color #66b3ff

.flex
    display flex

.flex-jc-c
    justify-content center

.gap-12
    gap 12px

.mg-t-16
    margin-top 16px

.mg-t-12
    margin-top 12px

.mg-t-20
    margin-top 20px

.mg-b-8
    margin-bottom 8px

.text-center
    text-align center

.fs-20
    font-size 20px

.fs-16
    font-size 16px

.bold
    font-weight bold

.fc-lightgray
    color #999

.pointer
    cursor pointer
</style>
